import React from "react";

import SubscriptionPageWrapper, {
  SubscriptionPageContent,
} from "../subscription/components/SubscriptionPageWrapper/SubscriptionPageWrapper";

function NoActiveSubscriptionPage() {
  return (
    <SubscriptionPageWrapper>
      <SubscriptionPageContent width={960}>
        No active subscription
      </SubscriptionPageContent>
    </SubscriptionPageWrapper>
  );
}

export default NoActiveSubscriptionPage;
